import { ISOString } from '@jumpstart/core';
import Badge from '@mui/material/Badge';
import Checkbox from '@mui/material/Checkbox';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import Slide from '@mui/material/Slide';
import Typography from '@mui/material/Typography';
import { collection, doc, Query, Timestamp, updateDoc } from 'firebase/firestore';
import moment from 'moment';
import React, { forwardRef, useState } from 'react';
import { useCollectionData } from 'react-firebase-hooks/firestore';
import { db } from '../../../core/firebase';
import { ISubscriber } from '../schemas';


import ReplyAll from './ReplyAll';

interface ISubscriberEnhanced extends ISubscriber {
  notifications: number;
  lastChecked?: ISOString;
}

export interface ISubscribersView {
  selected: ISubscriber | null;

  onSelect(subscriber: ISubscriber | null): void;
}

const Transition: any = forwardRef((props: any, ref: any) => <Slide direction="up" ref={ref} {...props} />);

// If last check exists today, then good, if not then not checked
const todayStart = moment().startOf('day');
const todayEnd = moment().endOf('day');
const defaultLastChecked = moment().subtract(1, 'day');

function SubscriberMenuItem(props: { subscriber: ISubscriberEnhanced; onSelect: (subscriber: ISubscriberEnhanced) => void; selected: ISubscriber | null }) {
  const { subscriber, onSelect, selected } = props;

  const labelId = `checkbox-list-secondary-label-${subscriber.uid}`;
  const handleCheck = (check: boolean) => {
    console.log('Handle Check...');
    updateDoc(
      doc(db, 'scout9-sms-subscribers', subscriber.uid),
      { lastChecked: check ? new Date().toISOString() : null }
    )
      .catch((err: Error) => {
        console.error('Failed', err);
      });
  };

  return (
    <ListItem
      key={subscriber.phone}
      button
      selected={!!selected ? subscriber.phone === selected.phone : false}
      onClick={() => {
        onSelect(subscriber);
      }}>
      {/*<ListItemAvatar>*/}
      {/*  <Avatar*/}
      {/*    alt={`Avatar n°${value + 1}`}*/}
      {/*    src={`/static/images/avatar/${value + 1}.jpg`}*/}
      {/*  />*/}
      {/*</ListItemAvatar>*/}
      <Badge badgeContent={subscriber.notifications} color="primary" invisible={subscriber.notifications < 1}>

        <ListItemText
          id={labelId}
          primary={subscriber.phone}
          secondary={`${subscriber.email ? subscriber.email : ''} ${subscriber.testUser ? '(T)' : ''}`}
          style={{ textDecoration: subscriber.end ? ' line-through' : 'unset' }}
        />
      </Badge>
      <ListItemSecondaryAction>
        <Checkbox
          edge="end"
          onChange={(event) => handleCheck(event.target.checked)}
          checked={subscriber.lastChecked ? moment(subscriber.lastChecked)
            .isAfter(todayStart) && subscriber.notifications === 0 : false}
          inputProps={{ 'aria-labelledby': labelId }}
        />
      </ListItemSecondaryAction>
    </ListItem>
  );

}

export default function SubscribersView(props: ISubscribersView) {
  const { onSelect, selected } = props;
  const [subscribers, loading] = useCollectionData<ISubscriber>(collection(db, 'scout9-sms-subscribers') as Query<ISubscriber>);
  const [replyAll, setReplyAll] = useState(false);
  // const [subscribers, setSubscribers] = useState<ISubscriber[]>([]);
  // const [lastKey, setLastKey] = useState<string>("");
  // const [nextSubscribersLoading, setNextSubscribersLoading] = useState(false);
  const sortSubscribers = (a: ISubscriberEnhanced, b: ISubscriberEnhanced) => b.notifications - a.notifications;

  // const fetchMore = (key: string) => {
  //   if (key.length > 0) {
  //     setNextSubscribersLoading(true);
  //     Post.postsNextBatch<ISubscriber>(key, db.collection(`scout9-sms-subscribers`), 'phone')
  //       .then(({data, lastKey}) => {
  //         setLastKey(lastKey);
  //         // add new posts to old posts
  //         setSubscribers(subscribers.concat(data));
  //         setNextSubscribersLoading(false);
  //       })
  //       .catch((err) => {
  //         console.error(err);
  //         setNextSubscribersLoading(false);
  //       });
  //   }
  // };
  //
  // useEffect(() => {
  //   // first 5 posts
  //   setNextSubscribersLoading(true);
  //   Post.postsFirstBatch<ISubscriber>(db.collection('scout9-sms-subscribers'), "phone")
  //     .then(({data, lastKey}) => {
  //       setSubscribers(data);
  //       setLastKey(lastKey);
  //       setNextSubscribersLoading(false);
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //       setNextSubscribersLoading(false);
  //     });
  // }, []);

  const enhance = (s: ISubscriber): ISubscriberEnhanced => {
    let notifications = 0;
    let minsLastSent = null;
    let minsLastReceive = null;
    if (s.lastSent) {
      minsLastSent = moment()
        .diff(moment(new Timestamp(s.lastSent.seconds, s.lastSent.nanoseconds).toDate()), 'minutes');
    }
    if (s.lastReceive) {
      minsLastReceive = moment()
        .diff(
          moment(new Timestamp(s.lastReceive.seconds, s.lastReceive.nanoseconds).toDate()),
          'minutes'
        );
    }

    // Message waiting for a reply
    if (s.phone === '+14254460552' || s.email === 'opiepat@gmail.com') {
      console.log(`PATRICK "${s.phone}" "${s.email}"`);
      console.log('Last time I sent ya', minsLastSent);
      console.log('Last time I heard from ya', minsLastReceive);
    }
    if (minsLastReceive) {
      if (typeof minsLastSent !== 'number') {
        console.log(s.phone, 'no last sent...');
        notifications++;
      } else if (minsLastReceive < minsLastSent) {
        console.log(s.phone, 'User waiting for reply...', minsLastReceive, minsLastSent);
        notifications++;
      }
    }

    // Message hasn't been sent in 48 hours
    // if (minsLastSent && minsLastSent > (48 * 60)) {
    //   notifications++;
    // }
    if (s.end) {
      notifications -= 100000;
    }
    return {
      ...s,
      notifications: notifications
    };
  };

  if (!subscribers) {
    return null;
  }

  return (
    <Grid
      container
      direction="column"
      wrap="nowrap"
      sx={{
        height: '100%',
        overflowY: 'scroll',
        width: '100%',
        maxWidth: 360,
        backgroundColor: (theme) => theme.palette.background.paper
      }}
    >

      <Dialog
        PaperProps={{ style: { height: '100%' } }}
        fullScreen
        TransitionComponent={Transition}
        keepMounted
        open={replyAll}
      >
        <ReplyAll
          subscribers={subscribers ? subscribers : []}
          onComplete={() => {
            setReplyAll(false);
          }}
          onClose={() => {
            setReplyAll(false);
          }}
        />
      </Dialog>
      <List dense>
        <React.Fragment>

          <ListItem button onClick={() => {
            setReplyAll(true);
          }}><ListItemText primary="Reply All"/></ListItem>

          {subscribers
            .map(enhance)
            .sort(sortSubscribers)
            .map((subscriber: ISubscriberEnhanced) => <SubscriberMenuItem
              key={subscriber.uid}
              subscriber={subscriber}
              selected={selected}
              onSelect={onSelect}
            />)}
        </React.Fragment>
      </List>
      {loading ? <CircularProgress size={16}/> :
        <Typography variant="caption" style={{ textAlign: 'center' }}>You are up to date!</Typography>}
    </Grid>
  );
}
